<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row>
		<b-col>
			<b-row>
				<b-col>
					<div v-if="!$store.state.isMobile" :class="expand ? 'collapsible expanded collapsible__restriction' : 'collapsible collapsed collapsible__restriction'">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image" @click="onToggleExpand">
									<b-img :src="LaneClosureRequest.getRestrictionImage(restrictionTypeId)" style="height:30px"></b-img>
								</div>
							<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand">{{LaneClosureRequest.getDirectionText(directionId)}} {{LaneClosureRequest.getRestrictionTypeText(restrictionTypeId)}}</div>
							<div class="collapsible-heading__status" @click="onToggleExpand"><div class="flex-table"><div class="flex-table-cell" v-html="getInEffectTitle()"></div></div></div>
							<div class="collapsible-heading__toggle">
								<div class="flex-table">
									<b-button href="#" variant="collapsible"
										:class="expand ? 'flex-table-cell' : 'flex-table-cell collapsed'"
										:aria-expanded="expand ? 'true' : 'false'"
										aria-controls="collapseRestrictionListing"
										@click="onToggleExpand"
										>
									<span class="when-opened">
									<font-awesome-icon icon="chevron-down" />
									</span>
									<span class="when-closed">
									<font-awesome-icon icon="chevron-right" />
									</span>
									</b-button>
								</div>
							</div>
							<div v-if="!$store.getters.isReadOnly()" class="collapsible-heading__set-buttons">
							<b-dropdown text="Set All">
								<b-dropdown-item @click="setAllYes()">In Place</b-dropdown-item>
								<b-dropdown-item @click="setAllNo()">Removed</b-dropdown-item>
							</b-dropdown>
						</div>
						</div>
						</div>

						<b-collapse id="collapseRestrictionListing" :visible="expand"  class="collapsible-entries">
							<div v-for="(p, uindex) in preset[0].restriction" v-if="p.restrictionTypeId.value == restrictionTypeId && p.directionId.value == directionId" class="collapsible-unique"  v-bind:key="'replcrprl-'+uindex+'-'+Math.random()">
									<div class="collapsible-entry__details">
								<div v-html="getPeakReasonText(uindex)"></div>
									</div>
									<div  v-if="isEntry(b2index, uindex)" v-for=" (b, b2index) in value" :key="'rbll2index'+b2index+'-'+renderCounter+'-'+Math.random()">
										<div v-for="(l2, l2index) in b.restriction" v-if="isStreetEntry(b2index, uindex, l2.crossStreet.value, l2index)" :class="flexClasses(b2index)" :key="'blr2lindex'+l2index+renderCounter+'-'+Math.random()">
										<div>
											<div class="ineffect-off-switch-field">
													<input :id="switchId('rrestriction',b2index,l2index,Format.makeId(l2.crossStreet.value))" :disabled=$store.getters.isReadOnly()  class="ineffect-off-switch" :checked="l2.inEffect.value == 1" type="checkbox" @change="toggleSwitch(b2index, l2index,l2.crossStreet.value)" >
													<label :for="switchId('rrestriction',b2index,l2index,Format.makeId(l2.crossStreet.value))"></label>
											</div>
										</div>
										<div class="flex-grow-1 pl-3">
											<div class="d-flex collapsible-entry__title-wrapper">
												<div class="flex-grow-1 collapsible-entry__title"><a href="#" @click="showOnMap(b.blockId, l2.crossStreet.value)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <span>{{b.fromStreet.value}}</span> and <span>{{b.toStreet.value}}</span> {{LaneClosureRequest.getRestrictionTypeText(restrictionTypeId)}} onto <strong>{{l2.crossStreet.value}}</strong></a></div>
												<div class="collapsible-entry__map-button"><b-button class="pl-2 pr-2 pt-2 pb-2" variant="text" type="button" @click="showOnMap(b.blockId, l2.crossStreet.value)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
											</div>
										</div>
										</div>
									</div>
							</div>
								</b-collapse>
							</div>
							<!-- End of desktop -->

							<div v-if="$store.state.isMobile"  :class="expand ? 'collapsible expanded collapsible__restriction' : 'collapsible collapsed collapsible__restriction'" style="position: relative">
								<div class="collapsible-heading">
									<div class="d-flex">
										<div class="collapsible-heading__image cycle-mobile" @click="onToggleExpand">
											<b-img :src="LaneClosureRequest.getRestrictionImage(restrictionTypeId)" fluid style="height:30px"></b-img>
										</div>
									<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand">
									{{LaneClosureRequest.getDirectionText(directionId)}} {{LaneClosureRequest.getRestrictionTypeText(restrictionTypeId)}}

									</div>
									<div @click="onToggleExpand" class="collapsible-heading__effect">
										<div class="w-100 flex-table"><div class="flex-table-cell" v-html="getInEffectTitle()"></div></div>
									</div>
									<div class="collapsible-heading__toggle">
										<div class="flex-table">
											<b-button href="#" variant="collapsible"
												:class="expand ? 'flex-table-cell' : 'flex-table-cell collapsed'"
												:aria-expanded="expand ? 'true' : 'false'"
												aria-controls="collapseRestrictionListing"
												@click="onToggleExpand"
												>
											<span>
											<font-awesome-icon icon="chevron-right" />
											</span>
											</b-button>
										</div>
									</div>
								</div>
								</div>
							</div>
							<div v-if="$store.state.isMobile && expand">
								<transition name="slide-fade" tag="div">
									<div class="d-block section-slide-panel has-menu" v-if="showPanel">
										<div class="top-controls">
											<button type="button" @click="onApply">
												<b-img src="/img/nav/icon-back.svg" alt="menu" /> Back
											</button>
										</div>
										<div class="panels-body panels-body-padded">
											<div class="panels-nav-title" v-html="getNavTitle"></div>
											<div class="panels-primary-title" v-html="getModalTitle"></div>
												<div v-for="(p, uindex) in preset[0].restriction" v-if="p.restrictionTypeId.value == restrictionTypeId && p.directionId.value == directionId" class="collapsible-unique" v-bind:key="'rlcrprl-'+uindex+'-'+Math.random()">
													<div class="panels-body-content">

													<div class="collapsible-entry__details">
														<div v-html="getPeakReasonText(uindex)"></div>
													</div>
													<div class="collapsible-entry" v-if="isEntry(b2index, uindex)" v-for=" (b, b2index) in value" :key="'rbll2index'+b2index+'-'+renderCounter+'-'+Math.random()">
														<div v-for="(l2, l2index) in b.restriction" v-if="isStreetEntry(b2index, uindex, l2.crossStreet.value, l2index)" class="d-flex" :key="'blr2lindex'+l2index+renderCounter+'-'+Math.random()">
															<div class="pt-3">
																<div class="ineffect-off-switch-field">
																	<input :id="switchId('rrestriction',b2index,l2index,Format.makeId(l2.crossStreet.value))" :disabled=$store.getters.isReadOnly() class="ineffect-off-switch" :checked="l2.inEffect.value == 1" type="checkbox" @change="toggleSwitch(b2index, l2index,l2.crossStreet.value)">
																	<label :for="switchId('rrestriction',b2index,l2index,Format.makeId(l2.crossStreet.value))"></label>
																</div>
															</div>
															<div class="flex-grow-1 pl-3">
																<div class="d-flex collapsible-entry__title-wrapper">
																	<div class="flex-grow-1 collapsible-entry__title"><a href="#" @click="showOnMap(b.blockId, l2.crossStreet.value)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <span>{{b.fromStreet.value}}</span> and <span>{{b.toStreet.value}}</span> {{LaneClosureRequest.getRestrictionTypeText(restrictionTypeId)}} onto <strong>{{l2.crossStreet.value}}</strong></a></div>
																	<div class="collapsible-entry__map-button">
																		<b-button class="pl-2 pr-2 pt-2 pb-2" variant="text" type="button" @click="showOnMap(b.blockId, l2.crossStreet.value)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px" /></b-button>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="panels-apply">
											<div class="d-flex">
												<div class="panels-apply__close"><b-button @click="setAllYes()" variant="light" class="close-button" type="button"><img src="/img/assets/set-all-close.svg" alt="" />In-Place</b-button></div>
												<div class="panels-apply__open"><b-button @click="setAllNo()" variant="light" class="open-button" type="button"><img src="/img/assets/set-all-open.svg" alt="" />Removed</b-button></div>
												<div class="panels-apply__save"><b-button @click="onApply" variant="secondary" class="save-button" type="button"><img src="/img/assets/icon-checkmark-blue.svg"/>Apply</b-button></div>
											</div>
										</div>


									</div>
								</transition>
							</div>


							<div v-if="1 == 2 && $store.state.isMobile" :class="expand ? 'collapsible expanded collapsible__restriction' : 'collapsible collapsed collapsible__restriction'">
								<div class="collapsible-heading">
									<div class="d-flex">
										<div class="collapsible-heading__image" @click="onToggleExpand">
									<b-img :src="LaneClosureRequest.getRestrictionImage(restrictionTypeId)"></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand">
									{{LaneClosureRequest.getDirectionText(directionId)}} {{LaneClosureRequest.getRestrictionTypeText(restrictionTypeId)}}
									
										</div>
									<div @click="onToggleExpand" class="collapsible-heading__effect">
										<div class="w-100 flex-table"><div class="flex-table-cell" v-html="getInEffectTitle()"></div></div>
									</div>
									<div class="collapsible-heading__toggle">
										<div class="flex-table">
										<b-button href="#" variant="collapsible" :class="expand ? 'flex-table' : 'flex-table-cell collapsed'" :aria-expanded="expand ? 'true' : 'false'" aria-controls="collapseRestrictionListing" @click="onToggleExpand">
											<span class="when-opened">
											<font-awesome-icon icon="chevron-down" />
											</span>
											<span class="when-closed">
											<font-awesome-icon icon="chevron-right" />
											</span>
											</b-button>
										</div>
									</div>
									<!-- <div class="collapsible-heading__set-buttons">
									<b-dropdown text="Set All">
										<b-dropdown-item @click="setAllYes()">In Place</b-dropdown-item>
										<b-dropdown-item @click="setAllNo()">Removed</b-dropdown-item>
									</b-dropdown>
								</div>-->
								</div>
								</div>

								<b-collapse id="collapseRestrictionListing" :visible="expand"  class="collapsible-entries">

							<div v-if="!$store.getters.isReadOnly()" class="collapsible-heading__set-buttons mb-2">
								<b-dropdown text="Set All">
									<b-dropdown-item @click="setAllYes(laneId)">In Place</b-dropdown-item>
									<b-dropdown-item @click="setAllNo(laneId)">Removed</b-dropdown-item>
								</b-dropdown>
							</div>

									<div v-for="(p, uindex) in preset[0].restriction" v-if="p.restrictionTypeId.value == restrictionTypeId && p.directionId.value == directionId" class="collapsible-unique" v-bind:key="'rlcrprl-'+uindex+'-'+Math.random()">
											<div class="collapsible-entry__details">
										<div v-html="getPeakReasonText(uindex)"></div>
											</div>
											<div class="collapsible-entry"  v-if="isEntry(b2index, uindex)" v-for=" (b, b2index) in value" :key="'rbll2index'+b2index+'-'+renderCounter+'-'+Math.random()">
												<div v-for="(l2, l2index) in b.restriction" v-if="isStreetEntry(b2index, uindex, l2.crossStreet.value, l2index)" class="d-flex" :key="'blr2lindex'+l2index+renderCounter+'-'+Math.random()">
												<div>
													<div class="ineffect-off-switch-field">
															<input :id="switchId('rrestriction',b2index,l2index,Format.makeId(l2.crossStreet.value))" :disabled=$store.getters.isReadOnly()  class="ineffect-off-switch" :checked="l2.inEffect.value == 1" type="checkbox" @change="toggleSwitch(b2index, l2index,l2.crossStreet.value)" >
															<label :for="switchId('rrestriction',b2index,l2index,Format.makeId(l2.crossStreet.value))"></label>
													</div>
												</div>
												<div class="flex-grow-1 pl-3">
													<div class="d-flex collapsible-entry__title-wrapper">
														<div class="flex-grow-1 collapsible-entry__title"><a href="#" @click="showOnMap(b.blockId, l2.crossStreet.value)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <span>{{b.fromStreet.value}}</span> and <span>{{b.toStreet.value}}</span> {{LaneClosureRequest.getRestrictionTypeText(restrictionTypeId)}} onto <strong>{{l2.crossStreet.value}}</strong></a></div>
														<div class="collapsible-entry__map-button"><b-button class="pl-2 pr-2 pt-2 pb-2" variant="text" type="button" @click="showOnMap(b.blockId, l2.crossStreet.value)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
													</div>
												</div>
												</div>
											</div>
									</div>
										</b-collapse>
									</div>


							</b-col>
						</b-row>


		</b-col>
	</b-row>
</template>

<script>
import LaneClosureRequest from './../models/LaneClosureRequest.js'
import Format from '../utility/Format'
import Vue from 'vue'

export default {
	name: 'ReportLaneClosureRequestBlockSidewalkListing',
	props: ['value', 'preset', 'restrictionTypeId', 'directionId', 'expand'],
	data() {
		return {
			isEditing: false,
			editingIndex: null,
			LaneClosureRequest: LaneClosureRequest,
			backupBlock: null,
			errorMsg: null,
			lastIndex: null,
			Format,
			backup: {},
			renderCounter:0,
			allSelected:null,
			showPanel: false,
		}
	},
	mounted() {
		this.showPanel = this.expand;
		Vue.prototype.$bus.$on('swipe:right:panel', this.onSwipeRight);
     },
     destroyed() {
		Vue.prototype.$bus.$off('swipe:right:panel', this.onSwipeRight);
     },
   watch: {

   },
	computed: {
		getNavTitle() {
			return "Report Turning Restrictions In-place/Removed" ;
		},
		getModalTitle() {
			return LaneClosureRequest.getDirectionText(this.directionId) + " " + LaneClosureRequest.getRestrictionTypeText(this.restrictionTypeId);
		},
		setAllOptions:function() {
			return 	[
			{ value:0, text:"All Removed"},
			{ value:1, text:"All In Effect"},
			{ value:2, text:"Some In Effect"}
			];
		},
		entries: function() {
			let that = this;
			return this.value.filter(function(entry) {
				let x = 0;
				if (entry.restriction) {
					for (x = 0; x < entry.restriction.length; x++) {
						if (entry.restriction[x].restrictionTypeId.value == that.restrictionTypeId &&
						entry.restriction[x].directionId.value == that.directionId) {
							return true;
						}
					}
				}
				return false;
			})
		},
		nonEntries: function() {
			let that = this;
			return this.value.filter(function(entry) {
				let x = 0;
				if (entry.restriction) {
					for (x = 0; x < entry.restriction.length; x++) {
						if (entry.restriction[x].restrictionTypeId.value == that.restrictionTypeId &&
						entry.restriction[x].directionId.value == that.directionId) {
							return false;
						}
					}
				}
				return true;
			})
		},
	},
	methods: {
		getChecked: function(bindex) {
			if (this.value) {
				if (this.value[bindex]) {
					for (var x = 0; x < this.value[bindex].restriction.length; x++) {
						if (this.value[bindex].restriction[x].restrictionTypeId.value == this.restrictionTypeId) {
							if (this.value[bindex].restriction[x].inEffect.value == 1) {
								return true;
							}
						}
					}
				}
			}
			return false;
		},
		toggleSwitch(bindex, index) {
			if (this.value) {
				if (this.value[bindex]) {
					this.$bus.$emit('report-restriction:toggle-restriction-in-effect', { block: bindex, restriction:index });
					/*
					for (var x = 0; x < this.value[bindex].restriction.length; x++) {
						if (this.value[bindex].restriction[index].restrictionTypeId.value == this.restrictionTypeId) {
							this.$bus.$emit('report-restriction:toggle-restriction-in-effect', { block: bindex, restriction:x });
						}
					}
					*/
				}
			}
		},
		getInEffectTitle() {
			var texts = [];
			texts["1"] = 0;
			texts["0"] = 0;
			texts["null"] = 0;
			if (this.value) {
				for (var index = 0; index < this.value.length; index++) {
					for (var x = 0; x < this.value[index].restriction.length; x++) {
						if (this.value[index].restriction[x].restrictionTypeId.value == this.restrictionTypeId &&
							this.value[index].restriction[x].directionId.value == this.directionId) {
							if (texts["" + this.value[index].restriction[x].inEffect.value]) {} else {
								texts["" + this.value[index].restriction[x].inEffect.value] = 0;
							}
							texts["" + this.value[index].restriction[x].inEffect.value]++;
						}
					}
				}
			}
			var html = "";
			if (texts["null"] > 0) {
				// not reported
				texts["0"] += texts["null"];
			}
			if (texts["1"] > 0) {
				// closed
				html += "<div class='status-circle r-in-place'>" + texts["1"] + "</div>";
			}
			if (texts["0"] > 0) {
				// open
				html += "<div class='status-circle r-removed'>" + texts["0"] + "</div>";
			}
			// if (texts["null"] > 0) {
			// 	// not reported
			// 	html += "<div class='status-circle r-not-reported'>" + texts["null"] + "</div>";
			// }
			return html;
		},
		getPeakReasonText(index) {
			let html = "";
			if (this.value) {

				if (this.preset[0].restriction[index]) {
					html = LaneClosureRequest.getRestrictionPeakIdText(this.preset[0].restriction[index].peakId.value);
					if (this.preset[0].restriction[index].peakId.value == 6 || this.preset[0].restriction[index].peakId.value == 13 || this.preset[0].restriction[index].peakId.value == 19) {
						html += "<br/>" + this.preset[0].restriction[index].peakReason.value;
					}
				}
			}
			return html;
		},

		getInEffectText(index,restrictionIndex) {
			if (this.value) {
				if (this.value[index]) {
					return LaneClosureRequest.getRestrictionInEffectText(this.value[index].restriction[restrictionIndex].inEffect.value);
				}
			}
			return null;
		},
		classes: function(index) {
			if (this.isEntry(index)) {
				return "is-entry";
			} else {
				return "is-not-entry";
			}
		},
		flexClasses: function(index) {
			if (this.isEntry(index)) {
				return "d-flex pt-0 pb-0 collapsible-entry";
			} else {
				return "d-flex pt-0 pb-0 collapsible-entry";
			}
		},

		isStreetEntry: function(index, uindex, streetName, l2index) {
			if (this.value) {
				if (this.preset[0].restriction[uindex]) {
					if (this.value[index]) {
						// for (var x = 0; x < this.value[index].restriction.length; x++) {
							if (
								this.value[index].restriction[l2index].restrictionTypeId.value == this.preset[0].restriction[uindex].restrictionTypeId.value &&
								this.value[index].restriction[l2index].directionId.value == this.preset[0].restriction[uindex].directionId.value &&
								this.value[index].restriction[l2index].peakId.value == this.preset[0].restriction[uindex].peakId.value &&
								this.value[index].restriction[l2index].crossStreet.value == streetName
							) {
								return true;
							}
						// }
					}
				}
			}
			return false;
		},
		isEntry: function(index, uindex, streetName) {
			if (this.value) {
				if (this.preset[0].restriction[uindex]) {
					if (this.value[index]) {
						for (var x = 0; x < this.value[index].restriction.length; x++) {
							if (
								this.value[index].restriction[x].restrictionTypeId.value == this.preset[0].restriction[uindex].restrictionTypeId.value &&
								this.value[index].restriction[x].directionId.value == this.preset[0].restriction[uindex].directionId.value &&
								this.value[index].restriction[x].peakId.value == this.preset[0].restriction[uindex].peakId.value
							) {
								return true;
							}
						}
					}
				}
			}
			return false;
		},
		canBeAdded: function(index, uindex) {
			if (this.value) {
				if (this.preset[0].restriction[uindex]) {
					if (this.value[index]) {
						for (var x = 0; x < this.value[index].restriction.length; x++) {
							if (
								this.value[index].restriction[x].restrictionTypeId.value == this.preset[0].restriction[uindex].restrictionTypeId.value &&
								this.value[index].restriction[x].directionId.value == this.preset[0].restriction[uindex].directionId.value &&
								this.value[index].restriction[x].peakId.value == this.preset[0].restriction[uindex].peakId
							) {
								return true;
							}
						}
					}
				}
			}
			// if (LaneClosureRequest.hasTrafficLaneInDirection(this.preset[0].restriction[uindex].restrictionTypeId.value,  this.value[index].directionId)) {
			// 	return true;
			// }
			// if (LaneClosureRequest.areDirectionsEquivalent(this.preset[0].restriction[uindex].directionId.value,this.value[index].directionId)) {
			// 	return true;
			// }


			return false;
		},
		switchId(prefix,block,id) {
			return prefix+"-"+block+"-"+id;
		},
		shouldShowChanges(idx) {
			if (this.isEditing) {
				return true;
			}
			return false;
		},
		editBlock: function(id) {
			Vue.prototype.$bus.$emit("block:edit-restriction",id);
		},
		showOnMap: function(id, streetName) {
			Vue.prototype.$bus.$emit("block:show-on-map",{id, type: "restriction", laneId: this.restrictionTypeId, streetName:streetName});
		},
		addBlock: function(laneId, blockId) {
			this.renderCounter++;
			Vue.prototype.$bus.$emit("block:list-add-restriction",{restrictionTypeId:this.restrictionTypeId,directionId:this.directionId, blockId:blockId});
		},
		toggleRemoveBlock: function(index) {
			this.renderCounter++;
			// Vue.prototype.$bus.$emit("block:list-remove-restriction",{restrictionTypeId:this.restrictionTypeId,directionId:this.directionId, blockId:blockId});
			if (this.isEntry(index)) {
				Vue.prototype.$bus.$emit("block:list-remove-restriction",{restrictionTypeId:this.restrictionTypeId,directionId:this.directionId, blockId:this.value[index].blockId});
			} else {
				Vue.prototype.$bus.$emit("block:list-add-restriction",{restrictionTypeId:this.restrictionTypeId,directionId:this.directionId, blockId:this.value[index].blockId});
			}

		},
		setAllYes: function() {
			this.renderCounter++;
			Vue.prototype.$bus.$emit("report-restriction:all-restrictions-in-effect",{restrictionTypeId:this.restrictionTypeId,directionId:this.directionId, inEffect:1});

		},
		setAllNo: function() {
			this.renderCounter++;
			Vue.prototype.$bus.$emit("report-restriction:all-restrictions-in-effect",{restrictionTypeId:this.restrictionTypeId,directionId:this.directionId, inEffect:0});
		},


		onReview: function() {
			Vue.prototype.$bus.$emit("block:list-expand-restriction",{restrictionTypeId:this.restrictionTypeId,directionId:this.directionId,expand:!this.expand});
		},

		onApply: function() {
			this.showPanel = false;
			setTimeout(() => {
				let that = this;
				Vue.prototype.$bus.$emit("block:list-expand-restriction",{restrictionTypeId:that.restrictionTypeId,directionId:that.directionId,expand:!that.expand});

			}, 250);
		},
		onSwipeRight() {
			if (this.showPanel) {
				this.showPanel = false;
				setTimeout(() => {
					let that = this;
					Vue.prototype.$bus.$emit("block:list-expand-restriction",{restrictionTypeId:that.restrictionTypeId,directionId:that.directionId,expand:!that.expand});
				}, 250);
			}
		},
		onToggleExpand: function() {
			Vue.prototype.$bus.$emit("block:list-expand-restriction",{restrictionTypeId:this.restrictionTypeId,directionId:this.directionId,expand:!this.expand});
		},
	}
}
</script>
